import { useMutation } from '@tanstack/react-query';

import * as api from './SyncApi';

export function useBibtexImportResult() {
  return useMutation({
    mutationFn: ({ file, year }: { file: File; year: number }) => api.getBibtexImportResult(file, year),
  });
}

export function useScopusImportResult() {
  return useMutation({
    mutationFn: (year: number) => api.getScopusImportResult(year),
  });
}
